import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import ElementUI from 'element-ui'
import '@/styles/reset.css'
import '@/utils/rem.js'
import BaiduMap from 'vue-baidu-map'
// 暂时不用英文
import i18n from './config/i18n'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.config.productionTip = false// 有了Vue.config.productionTip = false这句代码，它会阻止你显示生产模式的消息
Vue.use(ElementUI)
Vue.use(BaiduMap, {
  ak: 'uDCkOoGYz9fYbFOkF85OsGTpstz0Bdyc'
})
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
